import React from 'react';
import classNames from 'classnames';

export function Card({ children, className = '', ...rest }) {
  return (
    <div
      {...rest}
      className={classNames('bg-white rounded-lg shadow-md p-4', className)}
    >
      {children}
    </div>
  );
}

export function CardContent({ children, className = '' }) {
  return <div className={classNames('mt-2', className)}>{children}</div>;
}

export function CardHeader({ children, className = '' }) {
  return (
    <div className={classNames('border-b pb-2 mb-3', className)}>
      {children}
    </div>
  );
}

export function CardTitle({ children, className = '' }) {
  return (
    <h3 className={classNames('text-lg font-semibold', className)}>
      {children}
    </h3>
  );
}

export function CardFooter({ children, className = '' }) {
  return (
    <div className={classNames('pt-3 mt-3 border-t', className)}>
      {children}
    </div>
  );
}

export default Card;
